<ng-container *transloco="let t">
    <div class="blue-background" appBlueBackground></div>
    <header
        fxLayout="column"
        focusonnavigation=""
        aria-label="Get started"
        id="homepage-header"
        class="home-header-background"
        tabindex="-1"
    >
        <div
            fxFlexFill
            fxLayout="column"
            fxLayoutAlign="start center"
            class="home-header-section"
        >
            <div class="home-header-headline">
                <h1>{{ client?.clientName }}</h1>
                @if (client?.isEnabled) {
                <h2>{{ introduction }}</h2>
                }
            </div>
            @if (client?.isEnabled) {
            <div
                fxFlex="grow"
                fxLayout="row"
                fxLayoutAlign="center center"
                class="home-header-start"
            >
                @if (!hasProvider) {
                <button
                    mat-flat-button
                    class="call-to-action-button"
                    (click)="navigateToProgram()"
                >
                    {{ t("home.action") | uppercase }}
                </button>
                } @else {
                <div fxLayout="column" fxLayoutAlign="center center">
                    <button
                        mat-flat-button
                        name="Get Started"
                        class="call-to-action-button"
                        (click)="startApplication()"
                        [disabled]="providerUnavailable"
                        id="get-started-button"
                    >
                        {{ t("home.action") | uppercase }}
                    </button>
                    <!-- The provider could not be confirmed as this client's, so the button is
              closed. Said inline rather than in a snackbar: the message has to
              outlast a toast, or the student is left with a dead button and no
              explanation. -->
                    @if (providerUnavailable) {
                    <p class="provider-unavailable" role="alert">
                        {{ t("home.provider-not-verified") }}
                    </p>
                    }
                </div>
                }
            </div>
            } @if (!client?.isEnabled) {
            <div
                fxFlex="grow"
                fxLayout="row"
                fxLayoutAlign="center center"
                class="home-header-disabled"
                [innerHtml]="$safeNavigationMigration(client?.siteDisabledHtml)"
            ></div>
            }
        </div>
    </header>
    <main class="docs-homepage-promo">
        <span class="promo-header">{{
            t("home.step.header", { stepCount: steps.length })
        }}</span>
        <div
            class="docs-homepage-row docs-introduction"
            fxLayout="row wrap"
            fxLayout.sm="column"
            fxLayout.xs="column"
            fxLayoutAlign="center"
            fxFlex.sm="90%"
            fxFlex.xs="90%"
            fxFlexFill
        >
            @for (step of steps; track step; let i = $index) {
            <div class="docs-homepage-row-column">
                <span class="step-number">{{ i + 1 }}</span>
                <img
                    class="step-icon"
                    [src]="'assets/img/home-icons/' + step.icon"
                    alt="Step {{ i + 1 }}"
                />
                <span class="step-description">{{
                    t(step.descriptionKey)
                }}</span>
            </div>
            }
        </div>
    </main>
</ng-container>
